// extracted by mini-css-extract-plugin
export default {"expandContainer":"expandContainer-fiS26","content":"content-pyOMX","expand":"expand-wrjz_","autoHeight":"autoHeight-jgR6s"};